<div class="alert text-left" *ngIf="!inProgress.progress && (!!inProgress.message || !!inProgress.errorMessage)" 
    [ngClass]="{'alert-success': !!inProgress.message, 'alert-danger': !!inProgress.errorMessage}">
    <span *ngIf="!!inProgress.message"><i class="fa fa-check-circle-o"></i> {{inProgress?.message}}</span>
    <span *ngIf="!!inProgress.errorMessage"><i class="fa fa-check-circle-o"></i> {{inProgress?.errorMessage}}</span>
</div>